module.exports = __webpack_public_path__ + "static/mongo-8ef2458dbc2a3561c1d55e0feea55176.png";